export default function deleteDataCenterReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_DATA_CENTER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_DATA_CENTER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_DATA_CENTER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}